@if (!editCreelMappingActive) {
  <article>
    <form [formGroup]="runForm">
      <app-planning-item-date-select
        vdwDelayedClass="blurry-content-fix"
        [earliestStartDateControl]="runForm.controls.earliestStartDate"
        [minimumDurationControl]="runForm.controls.minimumDuration"
      ></app-planning-item-date-select>

      <div class="product">
        @if (isCarpet) {
          <mat-form-field>
            <mat-label>{{ 'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="creel"
              [objectName]="'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="CREEL_BASE_ROUTER_LINK"
              (selectClicked)="selectCreel()"
              [placeHolderText]="getUnknownItemPlaceholder()"
            >
            </vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'creel'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="machineQuality"
              [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="QUALITY_BASE_ROUTER_LINK"
              (selectClicked)="selectMachineQuality()"
              [placeHolderText]="getUnknownItemPlaceholder()"
            >
            </vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'machineQuality'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
        }
        @if (isWeaving) {
          <mat-form-field>
            <mat-label>{{ 'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="weaveProduct"
              [objectName]="'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="WEAVE_PRODUCT_BASE_ROUTER_LINK"
              (selectClicked)="selectWeaveProduct()"
            ></vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'weaveProduct'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
        }
        @if (isTufting) {
          <mat-form-field>
            <mat-label>{{ 'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="tuftProduct"
              [objectName]="'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="TUFT_PRODUCT_BASE_ROUTER_LINK"
              (selectClicked)="selectTuftProduct()"
            ></vdw-object-selection>
            <mat-error *vdwCanShowErrorForFormControl="'tuftProduct'; error: 'required'">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
        }

        @if (isPlastic) {
          <mat-form-field>
            <mat-label>
              {{ 'UTILITIES.TOOL.TOOL' | bmsTranslate: {count: 1} }}
              <span class="optional">({{ 'GENERAL.OPTIONAL' | bmsTranslate | lowercase }})</span>
            </mat-label>
            <vdw-object-selection
              (selectClicked)="selectTool()"
              formControlName="tool"
              [objectName]="'UTILITIES.TOOL.TOOL' | bmsTranslate: {count: 1} | lowercase"
              [baseRouterLink]="TOOL_BASE_ROUTER_LINK"
            ></vdw-object-selection>
          </mat-form-field>
        }
      </div>

      <app-production-orders-list></app-production-orders-list>
      <app-creel-mapping-display [canEditCreelMapping]="!hasOrders()" [creelForm]="runForm.controls.creel" (editCreelMapping)="editCreelMappingActive = true"></app-creel-mapping-display>
    </form>
  </article>

  @if (!isCompleted) {
    <footer>
      @if (!createItemMode) {
        @if (isCarpet) {
          <div class="button-skeleton-wrapper standard-btn">
            <button
              mat-icon-button
              class="mat-icon-action-button-lg-with-border"
              [matTooltip]="'MACHINE.ACTIONS.CREATE_PRODUCTION_ORDER' | bmsTranslate"
              [disabled]="!canCreateOrderForRun()"
              (click)="addOrderForRun()"
            >
              <mat-icon svgIcon="add-prod-order"></mat-icon>
            </button>
          </div>
        }

        <div class="button-skeleton-wrapper standard-btn">
          <button mat-icon-button class="mat-icon-action-button-lg-with-border" [disabled]="isStarted" [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate" (click)="delete()">
            <mat-icon svgIcon="trash"></mat-icon>
          </button>
        </div>
        <div class="button-skeleton-wrapper raised-btn">
          <button mat-flat-button color="primary" (click)="saveChanges()" [disabled]="runForm.invalid">
            {{ 'GENERAL.ACTIONS.SAVE' | bmsTranslate }}
          </button>
        </div>
      } @else {
        <button mat-flat-button color="primary" (click)="createItem()" [disabled]="runForm.invalid">
          {{ 'GENERAL.ACTIONS.CREATE' | bmsTranslate }}
        </button>
      }
    </footer>
  }
} @else {
  <article>
    <app-creel-mapping-edit [creelForm]="runForm.controls.creel"></app-creel-mapping-edit>
  </article>
  <footer>
    <button mat-stroked-button (click)="discardCreelMapChanges()">
      {{ 'GENERAL.ACTIONS.CANCEL' | bmsTranslate }}
    </button>
    <button mat-flat-button color="primary" (click)="confirmCreelMapChanges()">
      {{ 'GENERAL.ACTIONS.SAVE' | bmsTranslate }}
    </button>
  </footer>
}
